export default __webpack_public_path__ + "static/media/xreasy.2cb2a966.png";